import { WprBaseViewModeInfo } from '../../../../wpr-framework/mode/WprBaseViewMode';
import { HeaderComponentView } from '../HeaderComponentView';
import { WprDI_GlobalScopeModel } from '../../../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { WprModel } from '../../../../wpr-framework/view/deco/WprModel';
import { GlobalScopeInfo } from '../../../../scope/GlobalScopeInfo';

/**
 * ヘッダーモード
 */
export class HeaderMode extends WprBaseViewModeInfo<HeaderComponentView> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('HeaderMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('peach');
		// 20211125 JAL対応 START
		list.push('jal');
		// 20211125 JAL対応 END
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
		list.push('hankyu');
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） END
		list.push('default');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('agencyCode', {
			class: [
				{ mode: 'peach',	class: 'peach' },
				// 20211125 JAL対応 START
				{ mode: 'jal',		class: 'jal' },
				// 20211125 JAL対応 END
				// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
				{ mode: 'hankyu',		class: 'hankyu' },
				// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） END
				{ mode: 'other',	class: 'default' },
			],
		});
		this.addControl('headerBorder', {
			class: [
				{ mode: 'peach',	class: 'peach' },
				// 20211125 JAL対応 START
				{ mode: 'jal',		class: 'jal' },
				// 20211125 JAL対応 END
				// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
				{ mode: 'hankyu',		class: 'hankyu' },
				// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） END
				{ mode: 'other',	class: 'default' },
			],
		});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		const agencyInfo = this.getGlobalMode('agentcode');
		if (agencyInfo === '20396') 
			return 'peach';
		// 20211125 JAL対応 START
		else if (agencyInfo === '20414') 
			return 'jal';
		// 20211125 JAL対応 END
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
		else if (agencyInfo === '20435') 
			return 'hankyu';
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
		else 
			return 'default';
	}
	// --------------------------------------------------------------------------
}